// extracted by mini-css-extract-plugin
export default {"GroupElement":"GroupElement_GroupElement__sKdqe","AddGroupButton":"GroupElement_AddGroupButton__z08YH"};